

















import { AuthenticationStepType } from '@getaccept/lib-shared/src/authentication/types/enums/authentication-step-type';
import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { SigningMergeTagHelper } from '@getaccept/lib-shared/src/helpers/signing-merge-tag.helper';
import type { AuthenticationStep } from '@getaccept/lib-shared/src/authentication/types/authentication-step';

export default defineComponent({
  props: {
    consentStep: {
      type: Object as PropType<AuthenticationStep>,
      default: undefined,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const title = computed((): string => {
      switch (props.consentStep.type) {
        case AuthenticationStepType.GdprConsent:
          return t('header-gdpr');
        case AuthenticationStepType.TrackingConsent:
          return t('header-tracking');
        default:
          return null;
      }
    });

    const label = computed((): string => {
      switch (props.consentStep.type) {
        case AuthenticationStepType.GdprConsent:
          return t('checkbox-label-gdpr');
        case AuthenticationStepType.TrackingConsent:
          return t('checkbox-label-tracking');
        default:
          return null;
      }
    });

    const description = computed((): string => {
      let defaultText: string;
      switch (props.consentStep.type) {
        case AuthenticationStepType.GdprConsent:
          defaultText = t('default-gdpr-consent-text');
          break;
        case AuthenticationStepType.TrackingConsent:
          defaultText = t('default-tracking-consent-text');
          break;
      }
      return SigningMergeTagHelper.replaceTags(props.consentStep.data.text || defaultText, {
        entity: props.consentStep.data.textData?.entity,
      });
    });

    const toggleValue = () => {
      emit('change', !props.value, props.consentStep.type);
    };

    return {
      title,
      label,
      description,
      toggleValue,
    };
  },
});
